// import { awardingOrganisationsService } from "./../index";
import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Model,
  Opts,
  PagedResponse,
  LegacyPagedResponse,
  QueryParams,
  toPagedResponse,
} from "@ofqual/portal-core/core/types";

import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";

export class QualificationReferenceServiceSearch extends BaseRemoteService {
  public async search(
    params: QueryParams = {},
    opts: Opts
  ): Promise<PagedResponse<Model>> {
    const { acronym, ...coreParams } = params;
    coreParams.filter = `organisationacronym eq '${acronym}'`;

    const url = `${this.apiRoot}/qualifications${paramsToSearchString(
      coreParams
    )}`;
    const legacyResponse = await super.getRequest<LegacyPagedResponse<Model>>(
      url,
      opts
    );
    return toPagedResponse(legacyResponse);
  }
}
